import React from "react";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import AdminHeader from "../components/Admin/AdminHeader";
import { colors } from "../theme/theme";

const AdminLayout = ({ children, heading, actionButton }) => {
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: colors.primary,
      }}
    >
      <AdminHeader />
      <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2, flexWrap: "wrap", gap: 2 }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-Bold",
              fontSize: smScreen ? "24px" : "32px",
            }}
          >
            {heading}
          </Typography>
          {actionButton}
        </Stack>
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;
